/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'ArticleType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('articletype'); // main translation loaded for articletype
		$translatePartialLoader.addPart('predefinedarticletype'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/articletype/articletype-dialog.html';

		return {
			/* new state for entity articleType */
			/* to access: ui-ref="articletype.list.new" */
			/* url: hostname/articletype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'ArticleTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'ArticleTypeFactory',
									'NewArticleTypeFactory',
									function(ArticleTypeFactory, NewArticleTypeFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new ArticleType
										// - resuming the creation of a new new ArticleType AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return ArticleTypeFactory.get({ id: $stateParams.articleTypeId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewArticleTypeFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for articleType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for articleType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('articletype', {
		/* abstract state for entity articleType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/articletype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'ArticleTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('articletype.list', {
		/* list state for entity articleType */
		/* to access: ui-ref="articletype.list" */
		/* url: hostname/articletype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/articletype/articletypes.html',
				controller: 'ArticleTypeController',
			},
		},
	});

	$stateProvider.state('articletype.detail', {
		/* detail state for entity articleType */
		/* to access: ui-sref="articletype.detail" */
		/* url: hostname/articletype/detail/:articleTypeId */
		url: '/detail/:articleTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/articletype/articletype-detail.html',
				controller: 'ArticleTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'ArticleTypeFactory',
				function($stateParams, ArticleTypeFactory) {
					return ArticleTypeFactory.get({ id: $stateParams.articleTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/articletype/list/new */
	$stateProvider.state('articletype.list.new', getNewState());
	/* url: http://<hostname>/articletype/list/:articleTypeId/edit */
	$stateProvider.state('articletype.list.edit', getEditState('/:articleTypeId/edit'));
	/* url: http://<hostname>/articletype/detail/:articleTypeId/edit */
	$stateProvider.state('articletype.detail.edit', getEditState('/edit'));

	$stateProvider.state('article.list.newArticleType', getNewState('/articletype/new'));
});
